import React from 'react';
import { connect, ConnectedProps, IReactComponent } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import LeaderboardTeam from './LeaderboardTeam';
import LeaderboardSection from './LeaderboardSection';
import LeaderboardChallenge from './LeaderboardChallenge';
import LeaderboardChampionship from './LeaderboardChampionship';

import { LEADERBOARD_TAB } from 'resources/constants';

const deps = {
  selectedLeaderboardTab: state.challenge.visualisations.selectedLeaderboardTab,
};

const leaderboards: {
  [key in LEADERBOARD_TAB]: IReactComponent<
    Omit<ConnectedProps, keyof ConnectedProps>
  >;
} = {
  team: LeaderboardTeam,
  section: LeaderboardSection,
  challenge: LeaderboardChallenge,
  championship: LeaderboardChampionship,
};

function Leaderboard({
  selectedLeaderboardTab,
}: typeof deps & ConnectedProps): React.ReactElement {
  const LeaderboardComponent = leaderboards[selectedLeaderboardTab];

  return <LeaderboardComponent />;
}

export default connect(deps, Leaderboard);
